import React from "react";
import { DataPage } from "./DataComponent.js";
import { motion } from "framer-motion";
const Data = () => {
    return (
        <motion.div>

            <DataPage />
        </motion.div>
    );
};

export default Data;
